import { Popover } from 'antd';
import { IconProps, Lock, Unlock } from 'react-feather';
import { useIntl } from 'react-intl';

type Props = {
  onClick?: () => void;
  iconProps?: IconProps;
  disabled?: boolean;
  active?: boolean;
};

const StatusIcon: React.FC<Props> = ({
  onClick,
  iconProps,
  disabled,
  active,
}) => {
  const intl = useIntl();

  const Icon = active ? Unlock : Lock;

  return (
    <Popover
      content={intl.formatMessage({
        id: `commons.list.action.button.${active ? 'disable' : 'enable'}`,
      })}
    >
      <Icon
        style={disabled ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
        color={active ? 'green' : 'red'}
        size={20}
        cursor={'pointer'}
        onClick={!disabled ? onClick : undefined}
        {...iconProps}
      />
    </Popover>
  );
};

export default StatusIcon;
